import { createSlice } from "@reduxjs/toolkit";

import {
    getActiveTrackersDashboardDatasRedux,
    getBusinessAsync,
    getDestinationsDashboardDatasRedux,
    getSourcesDashboardDatasRedux,
} from "./dashboardDatas.asyncActions";

const initialState = {
    getAllDashboardDatas: {
        message: "",
        status: "idle",
        activeTrackers: [],
        destinations: [],
        sources: [],
        bussiness: [],
        isReqTrue: true,
        bussinesStatus: "idle",
    },
};

export const dashboardDatasSlice = createSlice({
    name: "allDashboardDatasState",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getActiveTrackersDashboardDatasRedux.pending, (state) => {
                state.getAllDashboardDatas.status = "loading";
            })
            .addCase(
                getActiveTrackersDashboardDatasRedux.fulfilled,
                (state, action) => {
                    state.getAllDashboardDatas.status = "idle";
                    state.getAllDashboardDatas.activeTrackers =
                        action.payload.data && action.payload.data;
                },
            )
            .addCase(
                getActiveTrackersDashboardDatasRedux.rejected,
                (state, action) => {
                    state.getAllDashboardDatas.status = "failed";
                },
            )
            .addCase(getDestinationsDashboardDatasRedux.pending, (state) => {
                state.getAllDashboardDatas.status = "loading";
            })
            .addCase(
                getDestinationsDashboardDatasRedux.fulfilled,
                (state, action) => {
                    state.getAllDashboardDatas.status = "idle";
                    state.getAllDashboardDatas.destinations =
                        action.payload.data && action.payload.data;
                },
            )
            .addCase(
                getDestinationsDashboardDatasRedux.rejected,
                (state, action) => {
                    state.getAllDashboardDatas.status = "failed";
                },
            )
            .addCase(getSourcesDashboardDatasRedux.pending, (state) => {
                state.getAllDashboardDatas.status = "loading";
            })
            .addCase(
                getSourcesDashboardDatasRedux.fulfilled,
                (state, action) => {
                    state.getAllDashboardDatas.status = "idle";
                    state.getAllDashboardDatas.sources =
                        action.payload.data && action.payload.data;
                },
            )
            .addCase(
                getSourcesDashboardDatasRedux.rejected,
                (state, action) => {
                    state.getAllDashboardDatas.status = "failed";
                },
            )
            .addCase(getBusinessAsync.pending, (state) => {
                state.getAllDashboardDatas.bussinesStatus = "loading";
            })
            .addCase(getBusinessAsync.fulfilled, (state, action) => {
                state.getAllDashboardDatas.bussinesStatus = "success";
                state.getAllDashboardDatas.bussiness =
                    action.payload.data && action.payload.data;
                state.getAllDashboardDatas.isReqTrue = false;
            })
            .addCase(getBusinessAsync.rejected, (state, action) => {
                state.getAllDashboardDatas.bussinesStatus = "failed";
                state.getAllDashboardDatas.isReqTrue = false;
            });
    },
});

export default dashboardDatasSlice.reducer;
